import React from 'react';
import {
	Grid,
	TextField,
	Box,
	Typography,
} from '@mui/material';
import { HairServiceInput } from '../../gql/graphql';
import { useShopDetails } from '../../hooks/use-shop';

interface BasicInfoTabProps {
	serviceData: Partial<HairServiceInput>;
	updateServiceData: (updates: Partial<HairServiceInput>) => void;
}

function BasicInfoTab({ serviceData, updateServiceData }: BasicInfoTabProps) {
	const { shopId, locationId } = useShopDetails();

	// Initialize shopId and locationId if not set
	React.useEffect(() => {
		if (!serviceData.shopId) {
			updateServiceData({ shopId, locationId });
		}
	}, []);

	const handleChange = (field: keyof HairServiceInput) => (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) => {
		updateServiceData({ [field]: event.target.value });
	};

	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Basic Service Information
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				Enter the core details about your service
			</Typography>

			<Grid container spacing={3}>
				{/* Service Name */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						required
						label="Service Name"
						name="name"
						value={serviceData.name || ''}
						onChange={handleChange('name')}
						helperText="Enter a clear, descriptive service name"
					/>
				</Grid>

				{/* Description */}
				<Grid item xs={12}>
					<TextField
						fullWidth
						multiline
						rows={6}
						label="Description"
						name="description"
						value={serviceData.description || ''}
						onChange={handleChange('description')}
						helperText="Detailed service description"
					/>
				</Grid>
			</Grid>
		</Box>
	);
}

export default BasicInfoTab;
